module.exports = __webpack_public_path__ + "img/charity_jar.6e65e0e6.jpg";